import { MenuCategories } from '../hooks/useGetCategories'

import MenuBottomBar from './MenuBottomBar'
import MenuDivider from './MenuDivider'
import MenuSection from './MenuSection'

export default function MenuMobilePanel({ categories }: { categories: MenuCategories }): React.ReactElement {
  const { learningTools, games, profile } = categories

  return (
    <div className="flex flex-col px-4 pb-6 pt-12" data-test-id="menu-mobile-panel">
      {profile && (
        <>
          <div className="px-1 py-2.5">
            <MenuSection category={profile} />
          </div>
          <MenuDivider />
        </>
      )}
      <div className="px-1 py-2.5">
        <MenuSection category={learningTools} />
      </div>
      <MenuDivider />
      <div className="px-1 py-2.5">
        <MenuSection category={games} />
      </div>
      <MenuDivider />
      <MenuBottomBar isStacked />
    </div>
  )
}
